import { Component,Input } from '@angular/core';
import {TPVServices} from "../../pages/tpv/services";

/**
 * Generated class for the TpvKeyboardExportableComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'tpv-keyboard-exportable',
  templateUrl: 'tpv-keyboard-exportable.html'
})
export class TpvKeyboardExportableComponent {
    @Input() screen_show: boolean = true;


  constructor(public tpvServices: TPVServices,) {
  }

}



// WEBPACK FOOTER //
// ./src/components/tpv-keyboard-exportable/tpv-keyboard-exportable.ts